import React, {useState,useEffect, useRef} from 'react';
import Icon from '../../assets/icons/icon';
function InputTextField({inputLabel, inputValue, changeHandler, blurHandler, errorMsg = "", inputType="text", disabled = false, helperMsg='', maxLength=null, leftIconConfigs=null}) {
    const errorStyles = { alignSelf: 'stretch', paddingLeft: 12, paddingRight: 12, paddingTop: 8, paddingBottom: 8, background: '#F8F8F8', boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)', borderRadius: 8, border: '1px #FDA29B solid', justifyContent: 'center', alignItems: 'center', gap: 8, display: 'inline-flex', height: '30px' }
    const regStyles = { alignSelf: 'stretch', paddingLeft: 12, paddingRight: 12, paddingTop: 8, paddingBottom: 8, background: '#F8F8F8', boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)', borderRadius: 8, border: '1px #D0D0D0 solid', justifyContent: 'center', alignItems: 'center', gap: 8, display: 'inline-flex', height: '30px' }
    const inputRef = useRef()
    useEffect(()=>{
        inputRef.current.value = inputValue
    }, [inputValue])
    return (
        <>
                <div style={{ width: '100%', maxWidth: '763px', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 12, display: 'inline-flex' }}>
                    <div style={{ justifyContent: 'flex-start', alignItems: 'flex-end', gap: 4, display: 'inline-flex' }}>
                        <div style={{ color: '#707070', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word' }}>{inputLabel}</div>
                    </div>
                    <div style={errorMsg.length > 0 ? errorStyles : regStyles}>
                        {leftIconConfigs && (
                            <div style={{ display: 'inline-flex', alignItems: 'center', transform: leftIconConfigs.rotate ? 'rotate(180deg)' : null }}>
                                <Icon name={leftIconConfigs.icon} size={20} className={""} adjust="fontello" color={leftIconConfigs.color ?? '#F95951'} viewBox="0 0 1024 700"/>
                            </div>
                        )}
                        <div style={{ flex: '1 1 0', height: 11, justifyContent: 'flex-start', alignItems: 'center', gap: 8, display: 'flex' }}>
                            <input
                                style={{ flex: '1 1 0', color: '#2F2F2F', fontSize: 16, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word',background: 'rgb(248, 248, 248)', border: 'solid 1px rgb(248, 248, 248)' }}
                                type={inputType}
                                ref={inputRef}
                                onChange={(e) => changeHandler !== undefined ? changeHandler(e) : null}
                                onBlur={(e) => blurHandler !== undefined ? blurHandler(e) : null}
                                disabled={disabled}
                                maxLength={maxLength ?? null}
                            />
                        </div>
                        {errorMsg.length > 0 && (
                            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                <Icon name="q-alert-octagon" size={20} className="" adjust="fontello" color='#F95951' viewBox="0 0 1024 700"/>
                            </div>
                        )}
                    </div>
                    <div style={{ alignSelf: 'stretch', color: '#DE3F35', fontSize: 12, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word' }}>{errorMsg}</div>
                    {helperMsg.length > 0 && (
                        <div style={{alignSelf: 'stretch', color: '#8D8D8D', fontSize: 12, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word'}}>{helperMsg}</div>
                    )}
                </div>
        </>
    )
}

export default InputTextField;
